import React, { useState } from "react";
import { Copy, Check, Terminal } from "lucide-react";

export const CliBlock = ({ commands = [], testId }) => {
  return (
    <div className="space-y-2" data-testid={testId}>
      {commands.map((c, i) => (
        <CliLine key={i} platform={c.platform} command={c.command} note={c.note} idx={i} />
      ))}
    </div>
  );
};

const CliLine = ({ platform, command, note, idx }) => {
  const [copied, setCopied] = useState(false);
  const copy = () => {
    navigator.clipboard.writeText(command);
    setCopied(true);
    setTimeout(() => setCopied(false), 1500);
  };
  return (
    <div className="rounded-md border border-zinc-800 bg-black overflow-hidden">
      <div className="flex items-center justify-between px-3 py-1.5 border-b border-zinc-800 bg-zinc-950">
        <span className="flex items-center gap-2 text-[11px] uppercase tracking-widest text-zinc-500 font-semibold">
          <Terminal className="h-3 w-3 text-blue-500" />
          {platform}
        </span>
        <button
          onClick={copy}
          data-testid={`copy-cli-btn-${idx}`}
          className="flex items-center gap-1 text-[11px] text-zinc-400 hover:text-white transition-colors"
        >
          {copied ? <Check className="h-3 w-3 text-emerald-500" /> : <Copy className="h-3 w-3" />}
          {copied ? "Copied" : "Copy"}
        </button>
      </div>
      <div className="px-3 py-2.5 font-mono text-[13px] text-emerald-300 whitespace-pre-wrap break-all">
        <span className="text-zinc-600 select-none">$ </span>
        {command}
      </div>
      {note && (
        <div className="px-3 py-1.5 border-t border-zinc-900 text-[12px] text-zinc-500 font-sans">
          {note}
        </div>
      )}
    </div>
  );
};
